import styled from 'styled-components';

import Input from '../../elements/Input/Input';

export const FormDropdownWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  visibility: hidden;
  background: white;
  border: 1px solid #ddd;
  padding: 0 0.5rem;
  border-radius: 10px;
  width: 20rem;
  box-shadow: 0 0.2rem 0.4rem rgb(0 0 0 / 10%);
  opacity: 0;
  transition:
    transform 0.2s,
    opacity 0.2s,
    visibility 0s linear 0.2s;
  will-change: transform;
  position: absolute;

  max-height: 354px;
  z-index: 2;
  overflow-y: auto;
  left: 0;
  top: calc(100% + 0.5rem);

  @media screen and (max-width: 768px) {
    width: auto;
  }

  &.visible {
    visibility: visible;
    opacity: 1;
  }
`;

export const FormOptionsWrapper = styled.div`
  width: 100%;
  padding: 10px 5px;
  border-bottom: 0.5px solid #979797;
  justify-content: center;

  &:first-child {
    margin-top: 10px;
  }

  &:last-child {
    margin-bottom: 10px;
    border: none;
  }
`;

export const FilterBorder = styled.div`
  display: flex;
  flex-grow: 1;
  border-radius: 10px;
  position: relative;
  height: 71px;
  &:hover {
    background: rgba(210, 210, 210, 0.2);
  }
`;

export const FormDropdownOptions = styled.label`
  display: flex;
  flex-grow: 1;
  font-weight: 400;
  cursor: pointer;
  font-size: 14px;
  line-height: 14px;
  align-items: center;
  padding: 20px 25px;
  width: 100%;
  height: 100%;
`;

export const InputSelection = styled(Input)`
  margin: 0;
  padding: 0;
  visibility: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
`;
